import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((url: string) =>
    $actions.requisite.downloadFileByUrl(dispatch, url),
  );
};
